var Common = /** @class */ (function () {
    function Common() {
    }
    Common.getDate = function () {
        var dateInString = new Date().toString();
        var splitTimestamp = dateInString.split(" ");
        var timeWithoutSec = splitTimestamp[4].substring(0, splitTimestamp[4].length - 3);
        var timeZone = splitTimestamp.slice(6, splitTimestamp.length);
        return "" + splitTimestamp[1] + " " + splitTimestamp[2] + " " + splitTimestamp[3] + " " + timeWithoutSec + " " + timeZone + " ";
    };
    Common.downloadCSV = function (csvData, fileNamePrefix) {
        var blob = new Blob([csvData], { type: "text/plain;charset=utf-8" });
        saveAs(blob, fileNamePrefix + Common.getDate() + ".csv");
    };
    ;
    return Common;
}());
module.exports = Common;
//# sourceMappingURL=common.js.map


// WEBPACK FOOTER //
// ./app/lib/smartorg/common.js